import { h } from "vue";
import List from "@/components/ui/objects/List";
const programs = {
  cts: {
    title: "Ciencias de la Tierra Sólida",
    description:
      "El programa de Ciencias de la Tierra Sólida (CTS) tiene por objetivo realizar investigaciones para contribuir en el conocimiento de la estructura interna de la tierra en el territorio peruano usando información sobre los parámetros geofísicos que definen la dinámica de las placas tectónicas.",
    subprograms: [
      {
        slug: "procesos-dinamica-interna",
        title: "Procesos de Dinámica Interna",
        content: () => [
          <p>
            Este subprograma se encarga del estudio y monitoreo de todos los
            procesos geofísicos que se originan en el interior de la Tierra
            debido a las variaciones de su energía interna produciendo
            terremotos y generando erupciones volcánicas, creación y
            reactivación de fallas en la corteza, movimiento de las placas
            tectónicas y efectos asociados como la generación de tsunamis, entre
            otros.
          </p>,
          <p>
            En el marco de este subprograma se han identificado cinco (05)
            líneas de investigación orientadas a conocer los procesos de
            dinámica interna de la Tierra:
          </p>,
          <List marked>
            <li>Dinámica de placas y sismotectónica</li>
            <li>Deformación de la corteza y estructuras volcánicas</li>
            <li>Patrones de sismicidad y efectos asociados</li>
            <li>
              Patrones pre-eruptivos y predicción de erupciones volcánicas
            </li>
            <li>Estructura interna de volcanes</li>
          </List>,
        ],
      },
      {
        slug: "procesos-fisicos-suelos",
        title: "Procesos Físicos de los Suelos",
        content: () => [
          <p>
            La física del suelo trata el estudio de las propiedades físicas del
            suelo y su comportamiento dinámico al ser afectadas por procesos
            internos de la Tierra como los sismos, erupciones volcánicas y
            agentes erosionales que controlan su morfología. La evaluación de
            las características físicas del subsuelo permite investigar el
            comportamiento de los suelos al paso de las ondas sísmicas, cuyos
            niveles de amplificación y periodos de respuesta son de gran
            incidencia para la planificación urbana de las ciudades. Los
            diferentes eventos sísmicos ocurridos en el Perú de variada magnitud
            han generado altos niveles de intensidad, con evidencia de daños
            observados post-sismo a nivel nacional. Diversos estudios muestran,
            que los suelos ante la incidencia de ondas sísmicas asociadas a
            movimientos débiles y/o fuertes, responden de acuerdo a sus
            condiciones locales, pudiendo estos modificar el contenido
            frecuencial de las ondas y/o generar amplificaciones de las ondas
            sísmicas.
          </p>,
          <p>
            En el marco de este subprograma se han identificado dos (02) líneas
            de investigación:
          </p>,
          <List marked>
            <li>Características geofísicas y dinámicas de suelos</li>
            <li>Fenomenología de suelos inestables</li>
          </List>,
        ],
      },
    ],

    lastpub: {
      title:
        "Sismotectónica del sismo de Arequipa del 16 de diciembre, 2020 (M5.5)",
      path: "https://repositorio.igp.gob.pe/handle/20.500.12816/4896",
      thumb:
        "https://repositorio.igp.gob.pe/bitstream/handle/20.500.12816/4896/Sismotectonica-del-sismo-de-Arequipa-del-16-de-diciembre-2020-%28M5.5%29.pdf.jpg?sequence=4&isAllowed=y",
      abstract:
        "La Comisión Multisectorial del ENFEN mantiene el estado del “Sistema de alerta ante El Niño y La Niña Costeros” como “No activo”, ya que la temperatura superficial del mar en la regiEn la región sur del Perú, el día 16 de diciembre del 2020 ocurre un sismo de magnitud moderada (M5.5) y epicentro ubicado a 44 km SO de la ciudad de Arequipa (región Arequipa). El sismo ocurrió a una profundidad de 93 km (foco intermedio) y en general, presentó un área de percepción con radio desde...",
    },
    community: "https://repositorio.igp.gob.pe/handle/20.500.12816/58",
    about: () => [
      <p>
        El programa de Ciencias de la Tierra Sólida tiene por objetivo
        contribuir al bienestar del país a través de los estudios de los
        parámetros geofísicos que permiten discernir lo que sucede en el
        interior de la Tierra. Tiene como función generar, promover, coordinar y
        ejecutar investigación científica y estudios interdisciplinarios en los
        campos de la Tierra Sólida, a través de líneas de investigación
        orientadas a conocer, ampliar y generar nuevo conocimiento geofísico
        para el desarrollo de la ciencia y contribuir al proceso de la
        estimación del peligro en la gestión del riesgo de desastres.
      </p>,
    ],
    slides: [
      "http://test.igp.gob.pe/paginaigp/images/slider/cts_slide_1.png",
      "http://test.igp.gob.pe/paginaigp/images/slider/cts_slide_2.png",
      "http://test.igp.gob.pe/paginaigp/images/slider/cts_slide_3.png",
      "http://test.igp.gob.pe/paginaigp/images/slider/cts_slide_4.png",
    ],
  },
  cah: {
    title: "Ciencias de la Atmósfera e Hidrósfera",
    description:
      "Este programa realiza investigación científica para generar evidencias que son base sólida para la toma de decisiones en la gestión de riesgos de desastres, el manejo del ambiente y la adaptación al cambio climático, entre otros....",
    subprograms: [
      {
        slug: "oscilacion-sur",
        title: "El Niño - Oscilación del Sur (ENSO)",
        content: () => [
          <p>
            El ENSO (El Niño-Oscilación del Sur) es un fenómeno natural que
            integra la dinámica del océano y la atmósfera y cuyas
            manifestaciones alteran el clima global. Los términos El Niño / La
            Niña corresponden a la fase positiva/negativa del ENSO en su
            componente oceánico el cual se define como el
            calentamiento/enfriamiento anormal y sostenido de la superficie del
            Océano Pacífico tropical. Por otra parte, el término Fenómeno El
            Niño (FEN) se asocia a perturbaciones climáticas como lluvias
            intensas en la costa norte y/o sequías en otras regiones del Perú,
            aumento de nivel del mar, entre otras. El ENSO (en el sentido más
            amplio de su definición) es un fenómeno recurrente, pero no
            periódico, en escala interanual.{" "}
          </p>,
          <p>
            Las investigaciones desarrolladas en este subprograma de
            investigación están orientadas a conocer mejor la naturaleza física
            del evento, los tipos de manifestaciones y sus impactos en el
            territorio nacional. De esta manera, se pretende contribuir a la
            generación de información y productos que ayuden a mejorar su
            pronóstico y los impactos que se generan durante su manifestación.
          </p>,
          <p>
            En el marco de este subprograma se han identificado tres (03) líneas
            de investigación:
          </p>,
          <List>
            <li>
              Mecanismos físicos asociados a la génesis de El Niño/La Niña y su
              predicción
            </li>
            <li>Efectos del ENSO en la dinámica atmosférica continental</li>
            <li>Impactos del ENSO en la hidrosedimentología</li>
          </List>,
        ],
      },
      {
        slug: "variabilidad-cambio-climatico",
        title: "Variabilidad y Cambio Climático en el Perú",
        content: () => [
          <p>
            El Perú debido a su ubicación geográfica y su topografía, posee
            diferentes climas, los cuales están afectados por la variabilidad
            del clima de escala regional y global. Este subprograma, considera
            estudiar las variaciones del clima a escalas temporales que van
            desde la escala intraestacional hasta la escala de cambio climático.
            Para conocer las causas de las variaciones del clima local, se
            identifican los procesos físicos y dinámicos locales, así como a
            nivel regional que condicionan los patrones climáticos asociados a
            los océanos, cuya variabilidad afectarán al clima local, mediante
            oscilaciones o teleconexiones. También se consideran las
            reconstrucciones del clima pasado y sus proyecciones futuras
            considerando los efectos antrópicos que influyen en la variabilidad
            natural del clima.
          </p>,
          <p>
            Se usan datos históricos, así como datos de modelos estadísticos y
            dinámicos para caracterizar el clima local, así como para
            identificar los factores que influyen en su variabilidad. Este
            conocimiento sirve para desarrollar modelos físicos y/o estadísticos
            que permitan mejorar los pronósticos a diversas escalas
            espacio-temporales en territorio peruano. Se analiza la interacción
            entre las diferentes escalas de variabilidad y el cambio climático,
            siendo importante los impactos que estos generan en la variabilidad
            de la dinámica costera y la corriente de Humboldt, la hidrología,
            los suelos y los ecosistemas.
          </p>,
          <p>
            El objetivo de este subprograma es generar conocimiento que apoye en
            la toma de decisiones y permita una gestión adecuada de los impactos
            de la variabilidad climática en el Perú, así como para las medidas
            de adaptación al cambio climático.
          </p>,
          <p>
            En el marco de este subprograma se han identificado seis (06) líneas
            de investigación:
          </p>,
          <List marked>
            <li>Dinámica del clima en el Perú</li>
            <li>Reconstrucciones paleoambientales en el Perú</li>
            <li>Efectos hidrológicos de la variabilidad climática</li>
            <li>Actividad antrópica y efectos ecosistémicos</li>
            <li>
              Dinámica y sensibilidad al cambio climático de los sistemas de
              afloramiento de bordes orientales
            </li>
            <li>Procesos radiativos y aerosoles</li>
          </List>,
        ],
      },
      {
        slug: "eventos-meteorologicos-hidroclimaticos",
        title: "Eventos Meteorológicos e Hidroclimáticos Extremos",
        content: () => [
          <p>
            Los eventos extremos en general definen como aquellos que ocurren
            muy rara vez, el 5% del tiempo, y pueden ser potencialmente
            peligrosos y generar riesgo en zonas con alta vulnerabilidad. El
            Perú, por su geografía, está expuesto a fenómenos climáticos, como
            El Niño, que generan eventos de lluvias extremas en la costa norte y
            sequías en los Andes centrales y el sur. Por otro lado, la sierra
            donde hay población y actividades agrícolas por encima de los 4000
            msnm, están expuestas a bajas temperaturas y heladas durante la
            temporada seca, alta insolación durante el día y a lluvias intensas
            durante la temporada húmeda, que causan huaicos, deslizamientos y
            avalanchas, a la vez que pueden ocurrir sequías y veranillos. La
            Amazonía, por su parte, también alterna periodos de sequías e
            inundaciones, así como friajes en la Amazonía con graves
            consecuencias para la población y el ecosistema.
          </p>,
          <p>
            Por ello, los eventos meteorológicos (de corta duración) e
            hidroclimáticos extremos serán objeto de estudios de este
            subprograma, con el propósito de conocer mejor la frecuencia, la
            intensidad, las tendencias y las proyecciones futuras de los mismos,
            así como caracterizar los eventos y conocer los procesos físicos y
            dinámicos que lo originan, a fin de generar herramientas que
            permitan elevar su predictibilidad en diferentes escalas de espacio
            y de tiempo. Para ello, será imprescindible elevar la capacidad de
            observación de las variables y fenómenos meteorológicos e
            hidro-climáticos sobre el territorio peruano, potenciar los
            observatorios o laboratorios e implementar nuevos puntos de
            monitoreo o campañas de mediciones usando instrumentos, como radares
            meteorológicos, que permitan obtener información para validar los
            modelos. Paralelamente, es imprescindible potenciar las capacidades
            de cálculo, de manera que sea posible la implementación de modelos
            numéricos a escala de tiempo y de clima.
          </p>,
          <p>
            Este subprograma también contempla realizar estudios sobre los
            impactos de los eventos meteorológicos e hidroclimáticos extremos en
            los ecosistemas, en la hidrología y suelos, así como el efecto de
            los aerosoles en la radiación, con el objeto de aportar conocimiento
            para la GRD.
          </p>,
          <p>
            En el marco de este subprograma se han identificado seis (03) líneas
            de investigación:
          </p>,
          <List marked>
            <li>Eventos meteorológicos extremos</li>
            <li>Eventos hidro-climáticos extremos</li>
            <li>Efectos de los eventos extremos en los sistemas ambientales</li>
          </List>,
        ],
      },
    ],
    lastpub: {
      title: "Comunicado Oficial ENFEN N°01-2021",
      path: "https://repositorio.igp.gob.pe/handle/20.500.12816/4899",
      thumb:
        "https://repositorio.igp.gob.pe/bitstream/handle/20.500.12816/4899/Comunicado_Oficial_ENFEN_N%c2%b001-2021.pdf.jpg?sequence=4&isAllowed=y",
      abstract:
        "La Comisión Multisectorial del ENFEN mantiene el estado del “Sistema de alerta ante El Niño y La Niña Costeros” como “No activo”, ya que la temperatura superficial del mar en la región Niño 1+2, que incluye la zona norte y centro del mar peruano, se mantendría dentro de su rango normal hasta abril, inclusive. Por su parte, La Niña en el Pacífico central tenderá a debilitarse en lo que resta del presente verano. Sin embargo, continuaría contribuyendo a la ocurrencia de lluvias superiores a lo normal en gran parte de los sectores central y sur del país durante lo que resta del verano, especialmente en la zona andina. En la selva peruana no se descartaría episodios de lluvia superiores a sus valores normales. La Comisión Multisectorial del ENFEN continuará monitoreando e informando sobre la evolución de las condiciones oceánicas y atmosféricas, y actualizando sus perspectivas.",
    },
    community: "https://repositorio.igp.gob.pe/handle/20.500.12816/55",
    about: () => [
      <p>
        El programa de Ciencias de la Atmósfera e Hidrósfera, tiene por ojetivo
        generar conocimiento sobre los fenómenos físicos que ocurren en el
        sistema climático (atmósfera, océano, suelo, criósfera y biósfera), los
        cuales interactúan entre sí, produciendo variaciones climáticas en
        diferentes escalas espaciales y temporales. Dicha labor se realiza con
        datos in situ obtenidos en los observatorios, laboratorios, campañas de
        observaciones y mediciones, así como información de sensores remotos y
        aquellos generados por los modelos numéricos. Se consideran también los
        datos históricos, así como reconstrucciones ambientales o registros
        paleoclimáticos. Toda esta gama de información es usada tanto para
        corregir y validar los modelos climáticos, hidrológicos,
        sedimentológicos, entre otros, así como para evaluar los impactos
        físicos del cambio climático en el Perú.
      </p>,
    ],
    slides: [
      "http://test.igp.gob.pe/paginaigp/images/slider/cah_slide_1.png",
      "http://test.igp.gob.pe/paginaigp/images/slider/cah_slide_2.png",
      "http://test.igp.gob.pe/paginaigp/images/slider/cah_slide_3.png",
      "http://test.igp.gob.pe/paginaigp/images/slider/cah_slide_4.png",
    ],
  },
  cga: {
    title: "Ciencias del Geoespacio y Astronomía",
    description:
      "Tiene por objetivo realizar investigaciones acerca de los fenómenos que ocurren en las capas más altas de la atmósfera terrestre y en el espacio que nos rodea, a fin de entender...",
    subprograms: [
      {
        slug: "aeronomia-clima-espacial",
        title: "Aeronomía y Clima Espacial",
        content: () => [
          <p>
            La variabilidad de los fenómenos en el Sol y del comportamiento del
            medio interplanetario es conocida como Clima o Tiempo Espacial 5 , y
            tienen efecto en las capas más altas y externas de la Tierra, como
            la magnetósfera y la ionósfera, generando perturbaciones en estas
            regiones cuyas características e impactos son variables. Estas
            regiones, denominadas geoespacio, también se ven afectadas por los
            procesos internos y superficiales de la Tierra, que generan
            perturbaciones que se pueden propagar hasta estas regiones.
          </p>,
          <p>
            Estas perturbaciones no sólo afectan las características físicas de
            estas capas altas sino también a las señales de radio frecuencia que
            se propagan a través de ellas. Por ello, el clima espacial tiene
            influencia sobre los sistemas de navegación y comunicación
            desarrollados por el hombre y en consecuencia en los medios de vida
            de las personas 6 . En el caso particular del Perú, al estar su
            territorio ubicado en la región del Ecuador magnético, nuestro país
            se ve afectado por fenómenos ionosféricos propios de esta región,
            por ejemplo, el electrochorro ecuatorial 7 y las burbujas de plasma
            o F-dispersa ecuatoriales 8 . Estas perturbaciones ionosféricas
            pueden degradar o bloquear comunicaciones satelitales o inducir
            errores significativos en los sistemas de posicionamiento y
            navegación, razón por la cual se requiere estudiar sus causas e
            impactos.
          </p>,
          <p>
            De este modo, con el fin de atender la problemática descrita
            anteriormente, se han identificado cuatro (04) líneas de
            investigación:
          </p>,
          <List marked>
            <li>Caracterización del geoespacio</li>
            <li>Física de la corona solar y medio interplanetario espacial</li>
            <li>Física de las inestabilidades ionosféricas</li>
            <li>
              Impacto de las perturbaciones ionosféricas en las tecnologías del
              país
            </li>
          </List>,
        ],
      },
      {
        slug: "meteoros-objetos-espaciales",
        title: "Meteoros y Objetos Espaciales",
        content: () => [
          <p>
            La Tierra es continuamente bombardeada por partículas y objetos de
            diferentes tamaños y composiciones. Algunas de estas partículas se
            desintegran en la atmósfera de la Tierra y tienen influencia en el
            proceso de circulación de la atmósfera pudiendo afectar la
            variabilidad de nuestro clima. Otros objetos, sin embargo, sí logran
            atravesar la atmósfera impactando directamente nuestra superficie.
            Esto representa una amenaza a la integridad tanto de la
            infraestructura física como de la vida de sus pobladores, por ello
            la relevancia de estudiar y monitorear los objetos que rodean la
            Tierra.
          </p>,
          <p>
            Este sub-programa ha identificado dos (02) líneas de investigación
            con el fin de dar respuesta a la pregunta de investigación
            planteada.
          </p>,
          <List marked>
            <li>Dinámica de meteoros y objetos espaciales</li>
            <li>
              Física de interacción entre objetos espaciales y
              ionósfera/atmósfera
            </li>
          </List>,
        ],
      },
      {
        slug: "astronomia",
        title: "Astronomía",
        content: () => [
          <p>
            Existen objetos astronómicos y regiones del espacio que sólo pueden
            ser observados desde el hemisferio sur de la Tierra y más
            específicamente desde nuestro país. Utilizando tanto instrumentación
            óptica como de radio frecuencia. Aplicando técnicas de procesamiento
            de señales e imágenes sobre los datos adquiridos, se pueden
            determinar diferentes parámetros físicos de estos objetos, como su
            tamaño, la distancia a la que se encuentran e inclusive su
            composición.
          </p>,
        ],
      },
    ],
    lastpub: {
      title:
        "Astrometric observations of the Potentially Hazardous Asteroid (52768) 1998 OR2 near its maximum approach to earth",
      path: "https://repositorio.igp.gob.pe/handle/20.500.12816/4868",
      thumb:
        "https://repositorio.igp.gob.pe/bitstream/handle/20.500.12816/4868/ATel%2313733.pdf.jpg?sequence=4&isAllowed=y",
      abstract:
        "Our team presents astrometric measurements of the PHA (52768) 1998 OR2 obtained close to its maximum approach to Earth. The observations were made from Observatorio Planetario Moche, located in Trujillo, Peru (Long. 79 00 39.2 W, Lat. 08 06 47.9 S, Alt. 48 m), on April 23, 24, 25 and 29, 2020. It is",
    },
    community: "https://repositorio.igp.gob.pe/handle/20.500.12816/56",
    about: () => [
      h(
        "p",
        {},
        "Este subprograma se encarEl programa de Ciencias del Geoespacio y Astronomía tiene por objetivo contribuir al bienestar del país generando conocimiento científico sobre los fenómenos que ocurren en las capas más altas de la atmósfera terrestre (particularmente en la ionósfera), así como, sobre la variabilidad del clima del espacio que rodea la Tierra.",
      ),
      h(
        "p",
        {},
        "Además, se busca promover la formación de conciencia en la sociedad sobre nuestra vulnerabilidad ante los peligros o impactos que estos fenómenos pueden generar sobre los medios de vida de las personas. También comprende prepararnos adecuadamente en el manejo de los posibles desastres que los eventos geoespaciales causen sobre el territorio peruano. Es mediante la investigación científica que se busca entender el origen y dinámica de estos fenómenos con el objetivo de poder modelar la formación de los mismos y así generar pronósticos de su ocurrencia que sean de utilidad al estado y a la sociedad en general.",
      ),
    ],
    slides: [
      "http://test.igp.gob.pe/paginaigp/images/slider/geoa_slide_1.png",
      "http://test.igp.gob.pe/paginaigp/images/slider/geoa_slide_2.png",
      "http://test.igp.gob.pe/paginaigp/images/slider/geoa_slide_3.png",
      "http://test.igp.gob.pe/paginaigp/images/slider/geoa_slide_4.png",
    ],
  },
  convocatoria: {
    title: "Convocatorias Prácticas",
    description:
      "El Instituto Geofísico del Perú, fiel al objetivo de fomentar el desarrollo e investigación en ciencias, presenta el programa de prácticas pre profesionales que se desarrolla en su sede del Radio Observatorio de Jicamarca. Así, por séptimo año consecutivo, convoca a estudiantes...",
    about: [
      {
        slug: "acerca-de",
        title: "Programa de Prácticas Pre Profesionales",
        content: () => [
          <p>
            <b>
              Experiencia en investigación científica y desarrollo tecnológico
              para universitarios
            </b>
          </p>,
          <p>
            El Ministerio del Ambiente (Minam), a través del Instituto Geofísico
            del Perú (IGP), fiel al objetivo de fomentar el desarrollo e
            investigación en ciencias, presenta el programa de prácticas
            preprofesionales —modalidad presencial— que se desarrolla en su sede
            del Radio Observatorio de Jicamarca. Por decimocuarto año
            consecutivo, convoca a estudiantes peruanos del 8°, 9° y 10° ciclo
            de todas las universidades del Perú, que cursen las carreras de
            Ingeniería Electrónica, Ingeniería de Sistemas, Matemáticas, Física
            y afines.
          </p>,
          <p>
            <b>¿Por qué participar del programa?</b>
          </p>,
          <List marked>
            <li>
              El programa del IGP, te brindará la oportunidad de formar parte de
              un centro de investigación de renombre internacional.
            </li>
            <li>
              Podrás desarrollar un proyecto en ingeniería o investigación bajo
              la asesoría de un investigador o ingeniero senior con una
              aplicación práctica.
            </li>
            <li>
              La propia dinámica de la institución te permitirá estar en
              constante contacto con investigadores del área de teledetección
              con radares de universidades extranjeras de alto nivel.{" "}
            </li>
            <li>
              Tendrás la oportunidad de participar en eventos nacionales y/o
              internacionales de acuerdo a los resultados del proyecto
              desarrollado.
            </li>
          </List>,
          <p>
            <b>Remuneración</b>
          </p>,
          <p>S/ 1500 mensuales.</p>,
        ],
      },
      {
        slug: "requisitos-postulacion",
        title: "Requisitos para postular",
        content: () => [
          <p>
            <b>PERFIL DE POSTULANTE</b>
          </p>,
          <List marked>
            <li>Programación en lenguajes de alto nivel-Básico.</li>
            <li>Conocimiento de diseño de hardware analógico y digital.</li>
            <li>Conocimiento intermedio de sistemas operativos Linux.</li>
            <li>
              Dominio de conceptos matemáticos incluyendo cálculo, ecuaciones
              diferenciales, álgebra lineal, etc.
            </li>
            <li>Conocimientos de adquisición y análisis de datos físicos.</li>
            <li>
              Conocimiento de física teórica y resolución de modelos matemáticos
              y sistemas físicos.
            </li>
            <li>Conocimiento de herramientas de simulación.</li>
            <li>
              Conocimiento de herramientas para visualización de datos, como
              librerías de python, matlab, etc.
            </li>
            <li>Conocimiento intermedio de inglés.</li>
          </List>,
          <p>
            <b>COMPETENCIAS DEL POSTULANTE</b>
          </p>,
          <List marked>
            <li>Trabajo en equipo.</li>
            <li>Pensamiento crítico.</li>
            <li>Proactividad.</li>
            <li>Creatividad.</li>
          </List>,
          <p>
            <b>DOCUMENTACIÓN SOLICITADA</b>
          </p>,
          <List marked>
            <li>
              Carta de interés, indicando su motivación de ingresar al programa
              de prácticas. (*)
            </li>
            <li>Constancia de notas. (*)</li>
            <li>
              Constancia de matrícula donde acredite que viene cursando el 8°,
              9° y 10° ciclo. (*)
            </li>
            <li>Carta de recomendación de un profesor y/o asesor. (*)</li>
            <li>
              Declaración jurada de no tener vínculo laboral con alguna
              institución pública o privada. (*)
            </li>
            <li>Constancia de tercio, quinto o décimo superior. </li>
          </List>,
          <p>(*) Cumplimiento obligatorio.</p>,
        ],
      },
      {
        slug: "cronograma",
        title: "Cronograma de postulación",
        content: () => [<p>-</p>],
      },
      {
        slug: "postula-aqui",
        path: "https://www.igp.gob.pe/convocatorias/",
        title: "Postula aqui",
      },
    ],
    postulantes: [],
    charlas: () => [
      <p>
        Durante el programa de prácticas preprofesionales, se organizarán
        diversos seminarios de capacitación, a fin de orientar al participante
        en temas relacionados con el proyecto a desarrollar e involucrarlo en el
        trabajo que se realiza en el Radio Observatorio de Jicamarca del IGP.
      </p>,
    ],
    resultados: () => [
      //<p>Los resultados del proceso de selección para el Programa de prácticas preprofesionales - verano 2023, será publicado el 21 de diciembre del presente año.</p>
    ],
  },
};

export default programs;
